import { GoogleAnalyticsClient } from '../../commonv2/modules/analytics';
import { SheEnv } from '../utils/envs';

declare const tracker: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track: (event: string, values: object) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  view: (data?: object) => any;
  user: (values: object) => number;
};

export enum EventCategory {
  COURSE = 'courses',
  NOTIFICATION = 'notifications',
  SESSION = 'sessions',
  TRIAL = 'trial',
  RESERVE = 'reserve',
  EVENT = 'event',
  WITHDRAWAL = 'withdrawal',
  STEP = 'step',
}

/**
 * General client for events
 * Dispatch the given event to several sources (e.g. Google Analytics / KARTE)
 */
export class SheEventClient {
  /**
   * Report the given event
   * @param category the category
   * @param eventName the event name
   * @param values the values
   */
  static async reportEvent(category: EventCategory, eventName: string, values: object) {
    await Promise.all([
      GoogleAnalyticsClient.sendGaEvent(category, eventName, values['_ga_label'], values['_ga_value'], values),
      this.reportKarteEvent(category, eventName, values),
    ]);
  }

  static async reportView(data?: object) {
    await this.reportKarteView(data);
  }

  static reportKarteUser(values: object) {
    if (this.hasKarte() && tracker.track) {
      tracker.user(values);
    }
  }

  private static hasKarte() {
    return typeof tracker !== 'undefined';
  }

  /**
   * Report a custom event to KARTE using its tracker API
   * https://developers.karte.io/docs/guide-event
   * @param category
   * @param eventName
   * @param values
   */
  static reportKarteEvent(category: EventCategory, eventName: string, values: object) {
    this.logKarteEvent(category, eventName, values);
    if (this.hasKarte() && tracker.track) {
      tracker.track(`${category}_${eventName}`, values);
    }
  }

  /**
   * Report a page view to KARTE using its tracker API
   * https://support.karte.io/post/5v4aleSyc6WlrcJVGdOXzy#2-2
   * @param data an arbitrary extra data to link with this page view
   */
  private static reportKarteView(data?: object) {
    if (this.hasKarte() && tracker.view) {
      tracker.view(data);
    }
  }

  /**
   * テスト用のKarteイベントのテスト用ヘルパー
   * windowオブジェクト内のネームスペースに、送信した全イベントのログを保存する
   * @param category
   * @param eventName
   * @param values
   * @private
   */
  private static logKarteEvent(category, eventName, values) {
    if (!SheEnv.isTest() && !SheEnv.isDevelopment()) {
      return;
    }
    if (typeof window === 'undefined') {
      return;
    }
    const KEY_FOR_KARTE = '__she_karte_events';
    window[KEY_FOR_KARTE] = window[KEY_FOR_KARTE] || [];
    window[KEY_FOR_KARTE].push({ category, eventName, values });
  }
}
